import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getFollowups } from '../../../api/lead';
import FollowupTable from './followupTable';

const Followups = () => {
    const location = useLocation();
    const loggedInuserType = localStorage.getItem("type");
    const queryParams = new URLSearchParams(location.search);
    const userType = queryParams.get('for');
    const [followups, setFollowups] = useState([])
    const [loadingData, setLoadingData] = useState(false)

    const fetchFollowups = async () => {
        setLoadingData(true);
        try {
            const [followupsData] = await Promise.all([
                getFollowups(loggedInuserType)
            ])
            // const isForbidden = [followupsData].some(
            //     data => [403, 404, 500].includes(data?.status)
            // );
            // if (isForbidden) {
            //     navigate("/internal/lead/login");
            //     return;
            // }
            if (followupsData.status) {
                // console.log(followupsData.data)
                setFollowups(followupsData.data)
            } else {
                console.warn('Error in fetching the Data');
            }
        } catch(error){
            console.error("Error in fetching the Data");
        } finally {
            setLoadingData(false)
        }
    }

    useEffect(() => {
        fetchFollowups();
    }, []);

    return loadingData == true ? (
        <div class="d-flex justify-content-center">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
    ) : (
        <div>
            <h2 className="mb-2 mt-4">Followups</h2>
            <FollowupTable data={followups}/>
        </div>
    )
}

export default Followups;